// extracted by mini-css-extract-plugin
export default {"prettyTable":"ReportListView_prettyTable__Ij2nP"};